`<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('library.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'library' }">{{ $t('library.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h3>本館開放時間</h3>
        <p>星期一至星期六：08:30 ~ 21:30</p>
        <p>週日、國定假日：08:30 ~ 18:00</p>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h3>閱覽規則</h3>
        <p>
          1.本講堂提供社會大眾，十方學生讀書閱覽，不收費用，免辦證件。<br>
          2.進出講堂請整肅儀容、保持安靜。<br>
          3.講堂內嚴禁煙酒、零食、用餐、或沖調飲料。<br>
          4.講堂內嚴禁替人佔位，公物不得攜出。<br>
          5.貴重財物請自行保管，若有遺失，本講堂概不負責。<br>
          6.洽借書籍、錄音帶時，請小聲交談，以免妨礙他人。<br>
          7.請愛惜講堂各項設施，並請遵守上述規定。
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h3>圖書借閱辦法</h3>
        <p>
          1.本講堂藏書歡迎各界人士借閱，免辦借書證，免繳費用。<br>
          2.外借者，請至櫃台登記，每次以三冊為限。<br>
          3.外借日期以兩周週為限，欲續借時可用電話聯絡，或親至本會辦理，續借以一次為限。<br>
          4.借閱書籍應妥加保護，如有污損、遺失者應負賠償之責。<br>
          5.借閱書籍逾期，經屢催不還者，取消其借閱資格。<br>
          6.借閱書籍閱讀後請歸還原處，或置於指定書架，以便管理人員歸類。<br>
          7.本講堂藏書全由十方善信捐贈並免費借閱切勿私取或破壞，以免遭罪咎。
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h3>影音光碟出借規則</h3>
        <p>
          1.於講堂內借用影音光碟視聽者，請洽櫃台。<br>
          2.外借者請至櫃台辦理登記，影音光碟以五片（MP3 六片）為限。<br>
            住在外縣市或偏遠地區者， 影音光碟以十片為限；若有特殊需要超過以上所限片數，則應以公文申請之。<br>
          3.借閱期限一週，續借時可用電話連絡，或親至本會辦理。續借以一次為限。<br>
          4.若有下列情形則暫時取消借閱該項資格：<br>
            (1)借閱影音光碟以五片（MP3 六片）未還者。<br>
            (2)住在外縣市或偏遠地區者影音光碟以十片（MP3 十二片）未還者。<br>
          5.借閱者對影音光碟，應妥加保管，如有損毀遺失，應負賠償之責，費用則由借閱者自行發心賠償之。<br>
          6.本講堂所有視聽器材，來自十方善信捐贈，外借亦無收取任何費用，望勿私取，或破壞免遭罪咎。
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'

import { BreadcrumbPlugin } from 'bootstrap-vue'
import { ImagePlugin } from 'bootstrap-vue'
import { TabsPlugin } from 'bootstrap-vue'

import i18n from '@/plugins/i18n.js'

Vue.use(BreadcrumbPlugin)
Vue.use(ImagePlugin)
Vue.use(TabsPlugin)

export default {
  i18n,
  name: "library",
  props: {
    // 
  },
  data() {
    return {
      // 
    }
  },
  methods: {
    // 
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  components: {
    // 
  },
  metaInfo() {
    return {
      title: this.$t('library.title'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
}
</script>